import { HIGH_MONTH_SENTINEL, LOW_MONTH_SENTINEL, Month } from './types';

const getCurrentMonth = (): Month => {
    return {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear()
    };
};

const areMonthsEqual = (m1: Month, m2: Month) => {
    return compareMonths(m1, m2) === 0;
};

const compareMonths = (m1: Month, m2: Month) => {
    return (m1.year - m2.year) * 12 + (m1.month - m2.month);
};

const monthsListIncludes = (months: Month[], month: Month) => {
    return months.find(m => areMonthsEqual(month, m)) !== undefined;
};

const incrementMonth = (month: Month, amount: number = 1) => {
    const clonedMonth = { ...month };

    clonedMonth.month += amount;

    while (clonedMonth.month > 12) {
        clonedMonth.month -= 12;
        clonedMonth.year++;
    }

    while (clonedMonth.month < 1) {
        clonedMonth.month += 12;
        clonedMonth.year--;
    }

    return clonedMonth;
};

const getMonthsBetweenRange = (initialMonth: Month, finalMonth: Month) => {
    if (areMonthsEqual(initialMonth, LOW_MONTH_SENTINEL) || areMonthsEqual(finalMonth, HIGH_MONTH_SENTINEL)) return [];

    let pointerMonth = { ...initialMonth };
    const months = [{ ...pointerMonth }];

    while (!areMonthsEqual(pointerMonth, finalMonth)) {
        pointerMonth = incrementMonth(pointerMonth);
        months.push({ ...pointerMonth });
    }

    return months;
};

const getFrequencyMonths = (frequency: string) => {
    if (frequency === 'monthly') {
        return 1;
    } else if (frequency === 'bimonthly') {
        return 2;
    } else if (frequency === 'quarterly') {
        return 3;
    }

    return 1;
};

export { getCurrentMonth, areMonthsEqual, compareMonths, monthsListIncludes, incrementMonth, getMonthsBetweenRange, getFrequencyMonths };